import { useTranslation } from 'react-i18next';

/**
 * Custom hook to get the current text direction based on the selected language
 * @returns {'rtl' | 'ltr'} - Text direction
 */
export const useDirection = () => {
  const { i18n } = useTranslation();

  // Arabic and Hebrew are RTL languages
  return i18n.language === 'ar' || i18n.language === 'he' ? 'rtl' : 'ltr';
};
